<div class="tab-list-header">
    <div class="content-wrapper">
        <a
            class="tab-list-item active"
            [class.active]="isActiveTab(paymentAccountLink)"
            [routerLink]="[paymentAccountLink]"
        >
            <span>{{ "PAYMENT.TABS.ACCOUNT" | translate }}</span>
        </a>
        <div
            class="tab-list-item"
            [class.active]="isActiveTab(paymentInfoLink)"
            [routerLink]="[paymentInfoLink]"
        >
            <span>{{ "PAYMENT.TABS.INFO" | translate }}</span>
        </div>
    </div>
</div>

<router-outlet></router-outlet>
